import { SVGProps } from "react";

export const ArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#383838"
        d="M6.8546 2.1002a.3419.3419 0 0 1 .0754.111.3375.3375 0 0 1-.0754.373l-5.667 5.5757h14.4646c.0922 0 .1807.036.2459.1002a.3392.3392 0 0 1 .1019.242.3392.3392 0 0 1-.1019.242.3506.3506 0 0 1-.2459.1002H1.1875l5.667 5.5757a.3394.3394 0 0 1 .0977.2408.3396.3396 0 0 1-.1019.239.351.351 0 0 1-.2429.1002.3506.3506 0 0 1-.2446-.0961L.1018 8.744a.3418.3418 0 0 1-.0753-.111.3374.3374 0 0 1 .0754-.3729l6.2609-6.1599a.3483.3483 0 0 1 .1128-.0741.3527.3527 0 0 1 .379.0741Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
